export default {
  methods: {
    getValidationState(validationContext) {
      const { dirty, validated, valid = null } = validationContext;
      return dirty || validated ? valid : null;
    },
  },
};
